<template>
  <v-container
      fluid
      style="padding: 0; height: 100vh"
  >
    <v-dialog v-model="applyOk">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Vielen Dank
        </v-card-title>
        <v-card-text style="padding-left: 16px">
          <p>Sie erhalten eine E-Mail mit einer Bestätigung</p>
        </v-card-text>
        <v-card-actions>

          <v-btn
              color="primary"
              text
              @click.stop="applyOk = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAgb">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          AGB
        </v-card-title>
        <v-card-text style="padding-left: 16px">
          <span style="white-space: pre;">{{ agb }}</span>
        </v-card-text>
        <v-card-actions>
          <v-checkbox v-model="sendData.acceptedAGB"
                      label="AGB akzeptieren"/>
          <v-btn
              color="primary"
              text
              :disabled="sendData.acceptedAGB===false"
              @click.stop="acceptAgb()"
          >
            Absenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-if="dialogItem !== null"
        v-model="dialog"
        persistent

    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ dialogItem.course.title }}
        </v-card-title>

        <h3 style="padding-left: 16px;margin-top: 8px;">Kursinformationen</h3>
        <v-card-text style="padding-left: 16px">
          <p style="font-weight: bold">Start: {{ dialogItem.start | moment("DD.MM.YYYY HH:mm") }} |
            Ende:
            {{ dialogItem.end | moment("DD.MM.YYYY HH:mm") }}</p>
          <p>Ort: {{ dialogItem.location }}</p>
          <p>{{ dialogItem.course.description }}</p>
        </v-card-text>

        <v-divider></v-divider>
        <h3 style="padding-left: 16px;margin-top: 8px;">Anmelder</h3>
        <h4 style="padding-left: 16px;margin-top: 8px;">Firmendaten</h4>
        <div style="padding-left: 16px; padding-right: 16px">
          <v-text-field v-model="sendData.companyName" label="Firmenname"/>
          <v-text-field v-model="sendData.companyStreet" label="Straße, Hausnummer"/>
          <v-text-field v-model="sendData.companyZip" label="PLZ"/>
          <v-text-field v-model="sendData.companyLocation" label="Ort"/>
          <v-text-field v-model="sendData.companyReference" label="Kundenreferenz"/>
          <v-text-field v-model="sendData.invoiceEmail" label="Besteller - E-Mail"/>
          <v-text-field v-model="sendData.invoicePhone" label="Besteller-Tel. *" required/>
        </div>

        <h4 style="padding-left: 16px;margin-top: 8px;">Rechnungsadresse, falls abweichend</h4>
        <div style="padding-left: 16px; padding-right: 16px">
          <v-text-field v-model="sendData.invoiceCompany" label="Firmenname"/>
          <v-text-field v-model="sendData.invoiceStreet" label="Strasse, Hausnummer"/>
          <v-text-field v-model="sendData.invoiceZip" label="PLZ"/>
          <v-text-field v-model="sendData.invoiceLocation" label="Ort"/>
          <v-text-field v-model="sendData.invoiceDeliveryEmail" label="Abweichende E-Mail-Adresse für den Rechnungsversand"/>
        </div>
        <v-divider/>

        <h3 style="padding-left: 16px;margin-top: 8px;">Teilnehmer</h3>
        <v-card v-for="(participant, index) in sendData.participants" :key="index" color="#efefef"
                style="padding: 16px; margin: 16px">
          <v-text-field v-model="participant.firstName" label="Vorname"/>
          <v-text-field v-model="participant.lastName" label="Nachname"/>
          <v-text-field v-model="participant.birthdateString"
                        label="Geburtstag (Format: 30.01.1980)"/>
          <v-text-field v-model="participant.email" label="Email"/>

          <v-checkbox v-if="dialogItem.course.canBorrowBooks"
                      v-model="participant.wantsToBorrowBooks"
                      label="Buch ausleihen"/>
          <v-text-field v-if="participant.wantsToBorrowBooks"
                        v-model="participant.borrowBooksAddress"
                        label="Lieferadresse Buch"/>
          <v-text-field v-if="dialogItem.course.lastAssessmentDateRequired"
                        v-model="participant.lastAssessmentDateString"
                        label="Datum der letzten Bewertung (Assessment)"/>
          <label v-if="participant.isValid(dialogItem.course.lastAssessmentDateRequired)"
                 style="color: forestgreen">Daten OK</label>
          <label v-else style="color: black">Daten unvollständig</label>
          <v-btn text color="error"
                 @click.stop="sendData.participants.splice(index,1)">
            Entfernen
          </v-btn>
        </v-card>

        <v-btn text color="info"
               @click.stop="sendData.participants.push(new PublicBuyCourseDateApplicant())">
          Neuen Teilnehmer hinzufügen
        </v-btn>

        <v-divider/>

        <h3 style="padding-left: 16px; margin-top: 8px;">Extras</h3>
        <v-card color="#efefef" style="padding: 16px; margin: 16px">
          <v-textarea v-model="sendData.comment" label="Notizen"/>
        </v-card>

        <h3 style="padding-left: 16px;margin-top: 8px;">Anhänge</h3>
        <v-card v-for="(attachment, index) in sendData.attachments" :key="index" color="#efefef"
                style="padding: 16px; margin: 16px">
          <p>{{ attachment.substring(attachment.indexOf("-") + 1) }}</p>
          <v-btn text color="error"
                 @click.stop="sendData.attachments.splice(index,1)">
            Entfernen
          </v-btn>
        </v-card>

        <v-file-input
            truncate-length="24"
            accept="*/**"
            v-model="filename"
            @change="uploadAttachment"
            label="Datei auswählen & hochladen (max. 3MB)"
        ></v-file-input>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              text
              @click="dialog = false"
          >
            Zurück
          </v-btn>
          <v-btn
              color="primary"
              text
              :loading="loading"
              :disabled="sendData.invoicePhone.length === 0 || sendData.invoiceEmail.length ===0 || sendData.companyName.length ===0 || sendData.companyStreet.length ===0 || sendData.companyZip.length ===0 || sendData.companyLocation.length ===0 || sendData.participants.length===0 || sendData.participants.every((item) => item.isValid(dialogItem.course.lastAssessmentDateRequired)) === false"
              @click.stop="getAgb()"
          >
            Abschicken
            <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-img
        style="height: 100%;object-fit: cover"
        :src="background"
        class="grey darken-4"
    >

      <div class="action">
        <v-card color="white" elevation="10" class="justify-center" min-width="50%">
          <v-card-title>
            <div>
              <h3 class="headline">Schulungen von Behrendt Consulting</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <h3 style="margin-top: 28px; margin-bottom: 16px;">Filter</h3>
            <v-select
                :items="filterTree"
                v-model="chosenTag"

                label="Kategorie"
                @change="changeTag"
                return-object
                item-text="name"
                item-value="value"
                dense
            ></v-select>
            <v-select
                v-if="subcategory.length >0"
                :items="subcategory"
                v-model="chosenSubTag"
                label="Schulung"
                item-text="name"
                return-object
                @change="changeSub"
                dense
            ></v-select>
            <v-select
                v-if="subSubcategory.length >0"
                :items="subSubcategory"
                v-model="chosenSubSubTag"
                label=""
                @change="changeSubSub"
                item-text="name"
                return-object
                dense
            ></v-select>
            <v-select
                v-if="subSubSubcategory.length >0"
                :items="subSubSubcategory"
                v-model="chosenSubSubSubTag"
                label="Schulung"
                item-text="name"
                @change="changeSubSubSub"
                return-object
                dense
            ></v-select>
            <v-select
                v-if="subSubSubSubcategory.length >0"
                :items="subSubSubSubcategory"
                v-model="chosenSubSubSubSubTag"
                label="Schulung"
                item-text="name"
                return-object
                dense
            ></v-select>
            <v-data-table
                sort-by="start"
                :headers="[{text: 'Titel', value: 'titel'},{text: 'Start', value: 'start'}, {text: 'Ende', value: 'ende'}, {text: 'Online', value: 'online'}, {text: 'Ort', value: 'location'}, {text: 'Preis', value: 'price'}, {text: 'Anmelden', value: 'register'}]"
                :items="items"
                :footer-props="{
    'items-per-page-options': [1000]
  }"
                item-key="name"
                height="50vh"
                class="elevation-1"
            >
              <template v-slot:item.titel="{ item }">
                <b>{{ item.course.title }}</b>
              </template>

              <template v-slot:item.start="{ item }">
                {{ item.start | moment("DD.MM.YYYY HH:mm") }}
              </template>

              <template v-slot:item.ende="{ item }">
                {{ item.end | moment("DD.MM.YYYY HH:mm") }}
              </template>

              <template v-slot:item.online="{ item }">
                <label v-if="item.course.online">Ja</label>
                <label v-else>Nein</label>
              </template>

              <template v-slot:item.location="{ item }">
                <b>{{ item.location }}</b>
              </template>

              <template v-slot:item.price="{ item }">
                <b>{{ item.course.price }}</b>
              </template>

              <template v-slot:item.register="{ item }">
                <v-btn text class="ma-2" color="info" @click.stop="register(item)">Anmelden</v-btn>
              </template>
            </v-data-table>
            <v-table dense>
              <template v-slot:default>
                <thead>
                <tr>

                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in items"
                    :key="item.id"
                >
                  <td>{{ item.start | moment("DD.MM.YYYY HH:mm") }}</td>
                  <td>{{ item.end | moment("DD.MM.YYYY HH:mm") }}</td>
                  <td v-if="item.course.online">Ja</td>
                  <td v-else>Nein</td>
                  <td>{{ item.location }}</td>
                  <td>{{ item.course.price }}</td>
                  <td>
                    <v-btn text class="ma-2" color="info" @click.stop="register(item)">Anmelden
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-table>
          </v-card-text>
        </v-card>
      </div>
    </v-img>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top>Fehler.</v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import PublicBuyCourseDate from "@/models/PublicBuyCourseDate";
import PublicBuyCourseDateApplicant from "@/models/PublicBuyCourseDateApplicant";
import sharedFilterTree from "@/api/filtertree";

function createEmptySendData() {
  return {
    participants: [],
    acceptedAGB: false,
    comment: "",
    invoiceCompany: "",
    invoiceStreet: "",
    invoiceZip: "",
    invoiceLocation: "",
    invoiceDeliveryEmail: "",
    invoicePhone: "",
    invoiceEmail: "",
    companyName: "",
    companyReference: "",
    companyStreet: "",
    companyZip: "",
    companyLocation: "",
    attachments: []
  };
}

export default {
  name: "PublicCourseList",
  data() {
    return {
      data: [],
      subcategory: [],
      subSubcategory: [],
      subSubSubcategory: [],
      subSubSubSubcategory: [],
      background: require("@/assets/background_start.jpg"),
      input: "",
      dialogItem: null,
      dialog: false,
      error: false,
      filename: null,
      applyOk: false,
      agb: "",
      loading: false,
      showAgb: false,
      validation: null,
      sendData: createEmptySendData(),
      chosenTag: null,
      chosenSubTag: null,
      chosenSubSubTag: null,
      chosenSubSubSubTag: null,
      chosenSubSubSubSubTag: null,
      filterTree: [
        {name: ""}, ...sharedFilterTree
      ],
    }
  },
  computed: {
    PublicBuyCourseDateApplicant() {
      return PublicBuyCourseDateApplicant
    },
    items() {
      if (this.chosenTag === null || this.chosenTag.name === "") {
        return this.data;
      }
      let filter;
      if (this.chosenSubSubSubSubTag !== null) {
        filter = this.chosenSubSubSubSubTag.tags[this.chosenSubSubSubSubTag.tags.length - 1];
      } else if (this.chosenSubSubSubTag !== null) {
        filter = this.chosenSubSubSubTag.tags[this.chosenSubSubSubTag.tags.length - 1];
      } else if (this.chosenSubSubTag !== null) {
        filter = this.chosenSubSubTag.tags[this.chosenSubSubTag.tags.length - 1];
      } else if (this.chosenSubTag !== null) {
        filter = this.chosenSubTag.tags[this.chosenSubTag.tags.length - 1];
      } else {
        filter = this.chosenTag.tags[this.chosenTag.tags.length - 1];
      }

      return this.data.filter((item) => item.course.tags.includes(filter));
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    changeTag() {
      console.log("I CHANGE TAG");
      this.chosenSubSubSubSubTag = null;
      this.subSubSubSubcategory = [];
      this.chosenSubSubSubTag = null;
      this.subSubSubcategory = [];
      this.chosenSubSubTag = null;
      this.subSubcategory = [];
      this.chosenSubTag = null;
      this.subcategory = [];
      console.log(this.chosenTag);
      if (this.chosenTag.name !== "") {
        this.subcategory = this.filterTree.filter(
            (item) => item.key === this.chosenTag.key)[0].children;
      }
    },
    changeSub() {
      this.chosenSubSubSubSubTag = null;
      this.subSubSubSubcategory = [];
      this.chosenSubSubSubTag = null;
      this.subSubSubcategory = [];
      this.chosenSubSubTag = null;
      let result = this.subcategory.filter((item) => item.key === this.chosenSubTag.key);
      if (result.length > 0) {
        this.subSubcategory = result[0].children;
      } else {
        this.subSubcategory = [];
      }
    },
    uploadAttachment(file) {
      if (file === null) {
        return;
      }
      this.$httpBuyCourseApi.uploadAttachment(file, (result) => {
        this.sendData.attachments.push(result);
        this.filename = null;
      }, (err) => {
        this.errorText = "Fehler. " + err;
        this.error = true;
        setTimeout(() => this.error = false, 5000);
        this.filename = null;
      });
    },
    changeSubSub() {
      this.chosenSubSubSubSubTag = null;
      this.subSubSubSubcategory = [];
      this.chosenSubSubSubTag = null;
      this.subSubSubcategory = [];
      let result = this.subSubcategory.filter((item) => item.key === this.chosenSubSubTag.key);
      if (result.length > 0) {
        this.subSubSubcategory = result[0].children;
      } else {
        this.subSubSubcategory = [];
      }
    },
    changeSubSubSub() {
      this.chosenSubSubSubSubTag = null;
      this.subSubSubSubcategory = [];
      let result = this.subSubSubcategory.filter(
          (item) => item.key === this.chosenSubSubSubTag.key);
      if (result.length > 0) {
        this.subSubSubSubcategory = result[0].children;
      } else {
        this.subSubSubSubcategory = [];
      }
    },
    apply() {
      this.sendData.participants.forEach((applicant) => {
        applicant.prepare();
      })
      this.loading = true;
      this.$httpBuyCourseApi.apply(this.dialogItem.course.id, this.dialogItem.dateId, this.sendData,
          (result) => {
            this.applyOk = true;
            this.loading = false;
            this.dialog = false;
            this.dialogItem = null;
            this.sendData = createEmptySendData();
          }, (err) => {
            this.errorText = "Fehler. " + err;
            this.error = true;
            setTimeout(() => this.error = false, 5000);
            this.loading = false;
          })
    },
    loadData() {
      this.$httpBuyCourseApi.getPublic((result) => {
        this.data = result;
      })
    },
    getAgb() {
      this.$httpBuyCourseApi.getAgb((result) => {
        this.agb = result;
        this.showAgb = true;
      }, (err) => {
        this.apply();
      })
    },
    acceptAgb() {
      this.showAgb = false;
      this.apply();
    },
    register(item) {
      //PublicBuyCourseDate
      this.dialogItem = item;
      this.dialog = true;
    }
  }
}
</script>

<style scoped>
.v-parallax__image {
  transform: none !important;
  width: 100% !important;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
